// import React from "react";
// import About from "../components/About";

// export default function AboutPage() {
//   return <About />;
// }
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import contentService from "../services/contentService";
import AboutUS from "../assets/AboutUsPNG.png";
import difference from "../assets/NexenDifference.png"
import ITservice from "../assets/ITservices.png"
import Advisoty from "../assets/Advisory.png"

export default function AboutPage() {
  const [aboutContent, setAboutContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init({ once: true, duration: 900, easing: "ease-in-out" });
    
    const fetchAboutContent = async () => {
      try {
        const response = await contentService.getAboutContent();
        if (response.success) {
          setAboutContent(response.data);
        } else {
          setError("Failed to load content");
        }
      } catch (err) {
        setError("Failed to load content");
        console.error("Error fetching about content:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutContent();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center" role="alert">
        {error}
      </div>
    );
  }

  return (
    <>
      {/* Spacer for sticky header */}
      <div style={{ height: 0 }} />

      {/* Top Banner */}
      <section className="py-2 position-relative overflow-hidden bg-white">
        <div className="container">
          <div className="row align-items-center gx-5">
            <div className="col-lg-7" data-aos="fade-right">
              <h1 className="fw-bold mb-3"
                style={{
                  fontSize: "2.6rem",
                  fontFamily: "'Poppins', sans-serif",
                  color: "#2e3d9c"
                }}
              >
                About <span style={{
                  background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                  color: "transparent",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text"
                }}>{aboutContent?.title || "NEXEN Consulting"}</span>
              </h1>
              <p className="fs-5 mb-3 text-secondary" style={{ maxWidth: 590 }}>
                {aboutContent?.description || "At NEXEN, we are committed to IT consulting for individuals and simplifying taxation, financial planning, and business operations. With years of experience in the industry, our team of expert tax professionals, accountants, financial advisors, and IT consultants work diligently to provide accurate, efficient, and strategic solutions tailored to your needs."}
              </p>
            </div>
            <div className="col-lg-5 text-center" data-aos="fade-left">
              <img
                src={AboutUS}
                alt="Nexen Consulting Team"
                className="img-fluid rounded shadow"
                style={{ maxHeight: 300, objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
        {/* Soft Decor Circle */}
        {/* <div
          aria-hidden
          className="position-absolute top-0 end-0 opacity-15"
          style={{ width: 150, height: 150, background: "linear-gradient(135deg,#6B46C1,#D53F8C)", borderRadius: "50%", filter: "blur(17px)" }}
        ></div> */}
      </section>

      {/* Unique Proposition Section */}
      <section className="py-5" style={{ background: "#faf6ff" }}>
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6" data-aos="fade-right">
              <h2 className="fw-bold mb-3 gradient-about" style={{ fontFamily: "'Poppins', sans-serif" }}>
                The Nexen Difference
              </h2>
              <ul className="list-unstyled fs-5 mb-0">
                <li className="mb-3">
                  <i className="bi bi-stars text-primary me-2"></i>
                  <b>Integrated Solutions:</b> We combine advanced IT strategy with expert tax advisory for complete client empowerment.
                </li>
                <li className="mb-3">
                  <i className="bi bi-clock-history text-pink me-2"></i>
                  <b>Personal Relationships:</b> Long-term, responsive support from advisors who know you by name—not just your file number.
                </li>
                <li className="mb-3">
                  <i className="bi bi-lightning-fill text-warning me-2"></i>
                  <b>Accuracy & Fast Response:</b> Cutting-edge tools plus hands-on consulting means you always receive precise, timely service.
                </li>
                <li>
                  <i className="bi bi-shield-check text-success me-2"></i>
                  <b>Transparency & Security:</b> Firm-wide ethical standards and strict confidentiality for your peace of mind.
                </li>
              </ul>
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <img
                src={difference}
                alt="Trust and Expertise"
                className="img-fluid rounded shadow"
                style={{ maxHeight: 220, objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
        <style>{`
          .gradient-about {
            background: linear-gradient(90deg, #6B46C1, #D53F8C 90%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
          }
          .text-pink { color: #D53F8C }
        `}</style>
      </section>

      {/* Services Overview Block */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6" data-aos="fade-up">
              <h3 className="fw-bold mb-4" style={{
                color: "#6B46C1",
                fontFamily: "'Poppins', sans-serif"
              }}>
                IT Consulting Services
              </h3>
              <p className="mb-3 fs-5 text-secondary">
                In addition to our tax services, NEXEN offers comprehensive IT consulting to empower your business evolution. Our IT experts specialize in:
              </p>
              <ul className="fs-6 mb-3">
                <li><b>Enterprise Architecture Evaluation</b></li>
                <li><b>Application Reviews & Process Optimization</b></li>
                <li><b>Business Process Re-Engineering</b></li>
              </ul>
              <p className="fs-6 mb-0 text-secondary">
                We ensure your technology supports your business objectives while delivering maximum value.
              </p>
            </div>
            <div className="col-lg-6 text-center" data-aos="fade-up" data-aos-delay="200">
              <img
                src={ITservice}
                alt="IT Consulting"
                className="img-fluid rounded shadow"
                style={{ maxHeight: 175, objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Tax Filing and Advisory Block */}
      <section className="py-5" style={{ background: "#fcf5fd" }}>
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6 text-center" data-aos="fade-down-right">
              <img
                src={Advisoty}
                alt="Tax Filing"
                className="img-fluid shadow rounded"
                style={{ maxHeight: 180, objectFit: "cover" }}
              />
            </div>
            <div className="col-md-6" data-aos="fade-down-left">
              <h3 className="fw-bold mb-4" style={{
                color: "#D53F8C",
                fontFamily: "'Poppins', sans-serif"
              }}>
                Tax Filing & Advisory Services
              </h3>
              <p className="fs-5 text-secondary">
                We specialize in tax preparation, tax planning, business tax consulting, compliance, and financial advisory services. Our goal: help you maximize deductions, minimize liabilities, and ensure full compliance with the latest tax regulations.
              </p>
              <ul className="mb-3 fs-6">
                <li><b>Personal & Business Tax Returns</b></li>
                <li><b>Strategic Tax Planning</b></li>
                <li><b>IRS & State Compliance</b></li>
                <li><b>Financial & Business Consulting</b></li>
              </ul>
              <p className="fs-6">By blending our tax expertise with innovative IT solutions, we help you navigate complexities, enhance efficiency, and focus on your core strengths.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process / Clients Trust Us Block */}
      <section className="py-5 bg-white border-top" data-aos="fade-up">
        <div className="container">
          <h3 className="fw-bold mb-4 text-center"
            style={{
              fontFamily: "'Poppins', sans-serif",
              color: "#6B46C1"
            }}>
            How We Work
          </h3>
          <div className="row text-center g-4">
            <div className="col-md-3">
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-calendar-check fs-2 text-primary mb-2"></i>
                <div className="fw-semibold" style={{color:"#000000"}}>Thorough Needs Analysis</div>
                <div className="text-secondary small">We start by deeply understanding your business or personal tax/IT goals.</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-lightning-charge fs-2 text-danger mb-2"></i>
                <div className="fw-semibold" style={{color:"#000000"}}>Custom Solutions</div>
                <div className="text-secondary small">Every strategy—tax, business, IT—is customized for you. No copy-paste advice.</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-check2-circle fs-2 text-success mb-2"></i>
                <div className="fw-semibold" style={{color:"#000000"}}>Multidisciplinary Team</div>
                <div className="text-secondary small">Your success is powered by CPAs, consultants, and IT specialists working as one.</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-heart-pulse fs-2 text-pink mb-2"></i>
                <div className="fw-semibold" style={{color:"#000000"}}>Lasting Relationships</div>
                <div className="text-secondary small">We don’t “set and forget.” We check in, adapt, and grow with you over time.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-5 bg-gradient text-white text-center" style={{
        background: "linear-gradient(90deg,#6B46C1 60%,#D53F8C 120%)",
      }}>
        <div className="container">
          <h2 className="fw-bold mb-3" style={{ fontFamily: "'Poppins', sans-serif", letterSpacing: ".5px", color: "#15d6ddff" }}>
            Ready for Strategic Solutions & Personalized Support?
          </h2>
          <p className="fs-5 mb-4" style={{ maxWidth: 620, margin: "0 auto" }}>
            Speak with Nexen’s team today and experience next-level tax, IT, and business consulting—all with a personal touch.
          </p>

          {/* Decorative blurred circles */}
          <Link
            to="/contact"
            className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
            style={{
              background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
              boxShadow: '0 4px 15px rgba(213, 63, 140, 0.6)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 30px rgba(213, 63, 140, 0.9)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(213, 63, 140, 0.6)';
            }}
          >
            Get Started
          </Link>
        </div>
      </section>

      {/* Bootstrap Icons CDN (if not global) */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
      />
    </>
  );
}
